module.exports = __webpack_public_path__ + "static/media/video.86d53dd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/video.mp4
// module id = oXTu
// module chunks = 0